import React from "react";
import { Container } from "@mui/material";

const CustomContainer = ({ children, id, display, alignItems }: any) => {
  return (
    <Container
      id={id}
      maxWidth="lg"
      sx={{
        pt: 2,
        pb: 6,
        mt: 8,
        bgcolor: "background.paper",
        display: display,
        alignItems: alignItems,
      }}
    >
      {children}
    </Container>
  );
};

export default CustomContainer;
